import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/RecommendationDeck.css';

const properties = [
  {
    id: 1,
    image:
      'https://images.unsplash.com/photo-1600585154526-990dced4db0d?q=80&w=1600&auto=format&fit=crop',
    price: '₹69.5L',
    info: '4 bd · 3 ba · 3,102 sqft',
    type: 'Villa for Sale · Pune',
  },
  {
    id: 2,
    image:
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=1600&auto=format&fit=crop',
    price: '₹1.2Cr',
    info: '5 bd · 4 ba · 4,500 sqft',
    type: 'Luxury House · Mumbai',
  },
  {
    id: 3,
    image:
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1600&auto=format&fit=crop',
    price: '₹84L',
    info: '3 bd · 2 ba · 2,100 sqft',
    type: 'Modern Apartment · Bangalore',
  },
  {
    id: 4,
    image:
      'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?q=80&w=1600&auto=format&fit=crop',
    price: '₹2.4Cr',
    info: '6 bd · 5 ba · 6,200 sqft',
    type: 'Premium Penthouse · Delhi',
  },
];

const RecommendationDeck = () => {
  const [cards, setCards] = useState(properties);

  const cycleCards = () => {
    setCards((prev) => {
      const updated = [...prev];
      const first = updated.shift();
      updated.push(first);
      return updated;
    });
  };

  return (
    <div className="landscape-deck-wrapper">
      <AnimatePresence>
        {cards.map((card, index) => {
          const isTop = index === 0;

          return (
            <motion.div
              key={card.id}
              className={`landscape-card ${isTop ? 'top-card' : ''}`}
              drag={isTop}
              onClick={() => {
                if (isTop) {
                  cycleCards();
                }
              }}
              dragConstraints={{
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              }}
              dragElastic={0.15}
              whileTap={{
                scale: 0.98,
                cursor: 'grabbing',
              }}
              onDragEnd={(e, info) => {
                const offset = info.offset.x;
                const velocity = info.velocity.x;

                if (
                  Math.abs(offset) > 100 ||
                  Math.abs(velocity) > 600
                ) {
                  cycleCards();
                }
              }}
              animate={{
                opacity: 1,
                scale: 1 - index * 0.04,
                y: index * -14,
                rotate: index % 2 === 0 ? -3 : 3,
                zIndex: cards.length - index,
              }}
              initial={{
                opacity: 0,
                scale: 0.92,
              }}
              transition={{
                type: 'spring',
                stiffness: 240,
                damping: 22,
                mass: 0.9,
              }}
            >
              <img
                src={card.image}
                alt=""
                className="landscape-card-image"
                draggable="false"
              />

              <div className="landscape-overlay" />

              <div className="landscape-card-content">
                <div className="landscape-price">
                  {card.price}
                </div>

                <div className="landscape-info">
                  {card.info}
                </div>

                <div className="landscape-type">
                  {card.type}
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="deck-drag-text">
        Drag properties
      </div>
    </div>
  );
};

export default RecommendationDeck;